import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useRef, useState } from 'react';
import './index.scss';

export default function ContentG() {
    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384027305/logo%2001.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384215510/logo%202.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384294458/logo%203.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384295186/logo%204.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384294798/logo%205.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384294987/logo%206.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384295830/logo%207.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384295383/logo%208.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384294616/logo%209.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384295594/logo%2010.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384295941/logo%2011.jpg',
        },
    ];

    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const [finalList, setFinalList] = useState<any[]>([]);

    useEffect(() => {
        if (!containerRef.current || list.length === 0) return;
        const GAP = 12;
        const update = () => {
            const containerWidth = containerRef.current!.offsetWidth;
            // 计算卡片宽度
            let cardWidth = 350;
            if (containerWidth <= 1024) {
                cardWidth = 120;
            } else if (containerWidth <= 1440) {
                cardWidth = 208;
            }

            const itemFullWidth = cardWidth + GAP;
            const singleWidth = list.length * itemFullWidth;

            // ⭐ 必须至少 2 份 list（循环块）
            let duplicatedCount = 2;
            // ⭐ 若单份不足 1 屏，则保证至少覆盖 2 屏
            while (singleWidth * duplicatedCount < containerWidth * 2) {
                duplicatedCount++;
            }
            const duplicated = Array.from({ length: duplicatedCount }, () => list).flat();
            setFinalList(duplicated);

            // 动画核心：只移动 1 份宽度
            contentRef.current?.style.setProperty('--move-distance', `${singleWidth}px`);
            contentRef.current?.style.setProperty('--move-duration', `${list.length * 4.5}s`);
        };

        update();
        const ro = new ResizeObserver(update);
        ro.observe(containerRef.current);
        return () => ro.disconnect();
    }, []);

    return (
        <div className={`editor-index-list-b1-business`}>
            <div className="index-list-b1-list-business" ref={containerRef}>
                <div className="index-list-b1-list-content-business" ref={contentRef}>
                    {finalList.map((itemA: any, index: number) => {
                        return (
                            <div key={index} className="index-list-b1-item-business">
                                <EcoImg pc={itemA.pc} className="index-list-b1-item-img-business" />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
